import { trackAnalyticsNew } from '../../../../lib/utils';

export const getNavigationCategoriesBarAnalytics = ({ analyticsSlug, url }) => (
  trackAnalyticsNew({
    url,
    location: 'page:header-nav:level-1',
    name: analyticsSlug,
  })
);
